import React, { useState } from 'react';
import axios from 'axios';
import styles from '../styles/manualIngest.module.css';

const ManualIngest: React.FC = () => {
  const [url, setUrl] = useState('');
  const [pdf, setPdf] = useState<File | null>(null);
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleUrlSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!url.trim()) return;

    setStatus('loading');
    setMessage('');

    try {
      const res = await axios.post('/api/ingest/url', { url });
      setStatus(res.data.success ? 'success' : 'error');
      setMessage(res.data.success ? '✅ URL ingested successfully!' : '❌ URL ingestion failed.');
    } catch (err) {
      console.error(err);
      setStatus('error');
      setMessage('❌ An error occurred while ingesting the URL.');
    }
  };

  const handlePdfSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!pdf) return;

    setStatus('loading');
    setMessage('');

    const formData = new FormData();
    formData.append('pdf', pdf);

    try {
      const res = await axios.post('/api/ingest/pdf', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setStatus(res.data.success ? 'success' : 'error');
      setMessage(res.data.success ? '✅ PDF ingested successfully!' : '❌ PDF ingestion failed.');
    } catch (err) {
      console.error(err);
      setStatus('error');
      setMessage('❌ An error occurred while ingesting the PDF.');
    }
  };

  return (
    <div className={styles.ingestContainer}>
      <h2>Manual Ingestion Tool</h2>

      {/* URL Ingestion */}
      <form onSubmit={handleUrlSubmit} className={styles.ingestForm}>
        <label className={styles.formLabel}>Paste Webpage URL</label>
        <input
          type="url"
          placeholder="https://example.com/article"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className={styles.urlInput}
        />
        <button type="submit" disabled={status === 'loading'} className={styles.submitButton}>
          {status === 'loading' ? 'Processing...' : 'Ingest URL'}
        </button>
      </form>

      {/* PDF Upload */}
      <form onSubmit={handlePdfSubmit} className={styles.ingestForm}>
        <label className={styles.formLabel}>Upload PDF</label>
        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setPdf(e.target.files?.[0] || null)}
          className={styles.fileInput}
        />
        <button type="submit" disabled={status === 'loading'} className={styles.submitButton}>
          {status === 'loading' ? 'Processing...' : 'Upload PDF'}
        </button>
      </form>

      {/* Status Message */}
      {status !== 'idle' && (
        <p className={`${styles.statusMessage} ${status === 'success' ? styles.statusSuccess : status === 'error' ? styles.statusError : styles.statusLoading}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default ManualIngest;
